/*------------ Begin Import Reception-----------------*/
import {
  CanBoNhanKetQuaKiemTraDeXuatPage,
  KetQuaCanBoNhanKetQuaKiemTraDeXuatPage
}
from './reception'
/*------------ End Import Reception-----------------*/


/*------------ Begin Import handle-letters-----------------*/
import {
  AddHandleLettersPage,
  HandleLettersPage,
  ThuHoiXuLyDonPage
}
from './handle-letters';

/*------------ Begin Import handle-letters-old-----------------*/
import {
  AddHandleLettersOldPage,
  HandleLettersOldPage,
  ThuHoiXuLyDonOldPage
}
from './handle-letters-old';
/*------------End Import handle-letters-----------------*/

/*------------ Begin Import Giai Quyet Don-----------------*/

import {
  GiaiQuyetDonPage,
  XuLyGiaiQuyetDonPage,
  TuGiaiQuyetDonPage,
  TruongPhongThuHoiPage
}
from './giai-quyet-don'

/*------------End Import Giai Quyet Don-----------------*/

/*------------ Begin Import Thống kê báo cáo-----------------*/

import {
  TongHopDonTreHanXuLy,
  TongHopDonTreHanGiaiQuyet,
  TongHopKetQuaGQDTCPage,
  TongHopKetQuaTiepCongDanPage,
  TongHopKetQuaGQDKNPage,
  TongHopKetQuaXuLyDonPage,
  TongHopKetQuaThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraDatDaiPage,
  TongHopKetQuaThanhTraChuyenNganhPage,
  TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraXayDungCoBanPage,
  TongHopKetQuaThanhTraTaiChinhNganSachPage,
  TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage,
  TongHopKetQuaThanhTraLaiPage,
  TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage,
  KetQuaKiemTraChiTietDoanhNghiepPage,
  KetQuaKiemTraTheoKeHoachDoanhNghiepPage,
  KetQuaKiemTraDotXuatDoanhNghiepPage,
  TongHopKetQuaThanhTraPage,
  TongHopKetQuaThanhTraThamNhungPage
}
from './thong-ke-bao-cao'

/*------------End Import Thống kê báo cáo-----------------*/

/*------------ Begin Import Thanh tra-----------------*/

import {
  DanhSachThanhTraPage,
  DanhSachThanhTraDaPheDuyetPage,
  ThemMoiDanhSachThanhTraPage,
  DanhSachCuocThanhTraPage,
  DanhSachDoiTuongTrungPage,
  ThemMoiCuocThanhTraPage,
  ChiTietCuocThanhTraPage,
  ChinhSuaCuocThanhTraPage,
  ThayTheCuocThanhTraPage,
  ChinhSuaCuocThanhTraDotXuatPage,
  ChiTietCuocThanhTraKeHoachPage
}
from './thanh-tra'

/*------------End Import Thanh tra-----------------*/

/*------------ Begin Import Theo Gioi Giam Sat-----------------*/

import {
  TinhHinhXuLyDonTaiDonViPage,
  TinhHinhXuLyDonTaiDonViConPage,
  DanhSachDonPage,
  DanhSachDonTheoKyPage,
  ThongKeGiamSatNhapDonCuPage,
  DanhSachThongKeGiamSatDonCuPage
}
from './theo-doi-giam-sat'

/*------------End Import Theo Gioi Giam Sat-----------------*/

/*------------ Begin Import Theo dõi thực hiện-----------------*/

import {
  DanhSachTheoDoiThucHienPage,
  XuLyTheoDoiThucHienPage,
  KetQuaXuLyTheoDoiThucHienPage
}
from './theo-doi-thuc-hien'

/*------------End Import Theo dõi thực hiện-----------------*/

/*------------ Begin Bo Sung Thong Tin-----------------*/
import {
  BoSungThongTinPage,
  BoSungThongTinLanhDaoPage,
  BoSungChuyenDonPage
}
from './bo-sung-thong-tin'

import {
  DanhMucCuocThanhTraTrungPage,
  DanhMucTongHopThanhTraPage
}
from './thanh-tra-trung'

/*------------End Import Bo Sung Thong Tin-----------------*/

export {
  /*------------ Begin Export-----------------*/

  HandleLettersOldPage,
  AddHandleLettersOldPage,
  ThuHoiXuLyDonOldPage,

  HandleLettersPage,
  AddHandleLettersPage,
  ThuHoiXuLyDonPage,

  CanBoNhanKetQuaKiemTraDeXuatPage,
  KetQuaCanBoNhanKetQuaKiemTraDeXuatPage,

  GiaiQuyetDonPage,
  XuLyGiaiQuyetDonPage,
  TuGiaiQuyetDonPage,
  TruongPhongThuHoiPage,

  TongHopDonTreHanXuLy,
  TongHopDonTreHanGiaiQuyet,
  TongHopKetQuaGQDTCPage,
  TongHopKetQuaTiepCongDanPage,
  TongHopKetQuaGQDKNPage,
  TongHopKetQuaXuLyDonPage,
  TongHopKetQuaThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraDatDaiPage,
  TongHopKetQuaThanhTraChuyenNganhPage,
  TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraXayDungCoBanPage,
  TongHopKetQuaThanhTraTaiChinhNganSachPage,
  TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage,
  TongHopKetQuaThanhTraLaiPage,
  TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage,
  KetQuaKiemTraChiTietDoanhNghiepPage,
  KetQuaKiemTraTheoKeHoachDoanhNghiepPage,
  KetQuaKiemTraDotXuatDoanhNghiepPage,
  TongHopKetQuaThanhTraPage,

  DanhSachThanhTraPage,
  DanhSachThanhTraDaPheDuyetPage,
  ThemMoiDanhSachThanhTraPage,
  DanhSachCuocThanhTraPage,
  DanhSachDoiTuongTrungPage,
  ThemMoiCuocThanhTraPage,
  ChiTietCuocThanhTraPage,
  ChinhSuaCuocThanhTraPage,
  ThayTheCuocThanhTraPage,
  ChinhSuaCuocThanhTraDotXuatPage,
  ChiTietCuocThanhTraKeHoachPage,

  TinhHinhXuLyDonTaiDonViPage,
  TinhHinhXuLyDonTaiDonViConPage,
  DanhSachDonPage,
  DanhSachDonTheoKyPage,
  ThongKeGiamSatNhapDonCuPage,
  DanhSachThongKeGiamSatDonCuPage,

  BoSungThongTinPage,
  BoSungThongTinLanhDaoPage,
  BoSungChuyenDonPage,

  DanhSachTheoDoiThucHienPage,
  XuLyTheoDoiThucHienPage,
  KetQuaXuLyTheoDoiThucHienPage,

  DanhMucCuocThanhTraTrungPage,
  DanhMucTongHopThanhTraPage,
  TongHopKetQuaThanhTraThamNhungPage

  /*------------End Export-----------------*/
};



// WEBPACK FOOTER //
// ./src/components/pages/index.js